import { render, staticRenderFns } from "./WorkerBasicDataForm.vue?vue&type=template&id=da198ec8&"
import script from "./WorkerBasicDataForm.vue?vue&type=script&lang=js&"
export * from "./WorkerBasicDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports